import { useQuery } from '@tanstack/react-query';
import { transacciones } from '../services/Credito';
import { TransacoesResponse } from '../types';

export const useTransacoes = (userId: string) => {
  return useQuery<TransacoesResponse, Error>({
    queryKey: ['transacoes', userId],
    queryFn: () => transacciones({ id_remoto: userId }),
    enabled: !!userId, 
  });
};
